import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { X } from "lucide-react";
import { mmkBackToMmkButtonStyles } from "./styles";
import { MmkPageShell } from "./mmk-page-shell";

interface QuizEmptyProps {
  onBack: () => void;
}

export const QuizEmpty: React.FC<QuizEmptyProps> = ({ onBack }) => {
  return (
    <MmkPageShell>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          py: 6,
          px: 3,
        }}
      >
        <Typography
          variant="h6"
          sx={(theme) => ({
            fontWeight: 600,
            textAlign: "center",
            mb: 2,
            color:
              theme.palette.mode === "dark"
                ? theme.palette.common.white
                : theme.palette.text.primary,
          })}
        >
          Not enough cards for quiz
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: "text.secondary", textAlign: "center", mb: 3 }}
        >
          You need at least 3 "I Know It" and 2 "Review Later" cards to start a
          quiz.
        </Typography>
        <Button
          variant="outlined"
          onClick={onBack}
          sx={mmkBackToMmkButtonStyles}
          startIcon={<X size={18} />}
        >
          Back to MMM
        </Button>
      </Box>
    </MmkPageShell>
  );
};
